import {
  FileAttachment,
  NavigationRoute,
  ResponseSegment,
} from 'further-types/lp/ai-agent';

export type NavigationItem = {
  route: NavigationRoute;
  label: string;
  description?: string;
};

export type PendingInvoice = {
  base64: string;
  mediaType: FileAttachment['mediaType'];
  fileName: string;
  uploadedPath: string;
  uploadedName: string;
  uploadedPreview: string;
};

export type ChatMessage =
  | { role: 'user'; content: string; fileName?: string; timestamp: Date }
  | {
      role: 'assistant';
      content: string;
      segments: Array<ResponseSegment>;
      pendingInvoice: PendingInvoice | null;
      timestamp: Date;
    }
  | { role: 'action'; content: string };

export type ResizeDir = 'n' | 's' | 'e' | 'w' | 'ne' | 'nw' | 'se' | 'sw';

export const CREATE_ROUTES = new Set<NavigationRoute>([
  NavigationRoute.IncomeAdd,
  NavigationRoute.ExpenseAdd,
  NavigationRoute.InvestmentCreate,
  NavigationRoute.RealisationCreate,
  NavigationRoute.CapitalActionCreate,
  NavigationRoute.ManualJournalCreate,
  NavigationRoute.HoldingsCreate,
  NavigationRoute.EqualisationsAdd,
  NavigationRoute.PartnerTransfersCreate,
]);

export const INITIAL_WIDTH = 480;
export const INITIAL_HEIGHT = 620;
export const MIN_WIDTH = 360;
export const MIN_HEIGHT = 300;
